export var MenuCssClass;
(function (MenuCssClass) {
    MenuCssClass["Base"] = "iress-menu";
    MenuCssClass["Fluid"] = "iress-menu--fluid";
    MenuCssClass["Inline"] = "iress-menu--inline";
})(MenuCssClass || (MenuCssClass = {}));
export var MenuType;
(function (MenuType) {
    MenuType["Menu"] = "menu";
    MenuType["List"] = "list";
    MenuType["Listbox"] = "listbox";
    MenuType["Nav"] = "nav";
})(MenuType || (MenuType = {}));
export var MenuLayout;
(function (MenuLayout) {
    MenuLayout["Stack"] = "stack";
    MenuLayout["Inline"] = "inline";
    MenuLayout["InlineEqualWidth"] = "inline-equal-width";
})(MenuLayout || (MenuLayout = {}));
//# sourceMappingURL=menu.types.js.map